// Top 10 South African tertiary institutions with application links
export const institutions = [
  // Top 10 Universities
  {
    name: 'University of South Africa (UNISA)',
    type: 'University',
    applyUrl: 'https://www.unisa.ac.za/sites/corporate/default/Apply-for-admission'
  },
  {
    name: 'University of Pretoria',
    type: 'University',
    applyUrl: 'https://www.up.ac.za/online-application'
  },
  {
    name: 'University of Johannesburg',
    type: 'University',
    applyUrl: 'https://www.uj.ac.za/admission-aid/undergraduate/'
  },
  {
    name: 'University of KwaZulu-Natal',
    type: 'University',
    applyUrl: 'https://applications.ukzn.ac.za/'
  },
  {
    name: 'University of Cape Town',
    type: 'University',
    applyUrl: 'https://applyonline.uct.ac.za/'
  },
  {
    name: 'Stellenbosch University',
    type: 'University',
    applyUrl: 'https://www.sun.ac.za/english/maties/apply'
  },
  {
    name: 'University of the Witwatersrand',
    type: 'University',
    applyUrl: 'https://www.wits.ac.za/applications/'
  },
  {
    name: 'University of the Western Cape',
    type: 'University',
    applyUrl: 'https://www.uwc.ac.za/study-at-uwc/apply-now'
  },
  {
    name: 'Rhodes University',
    type: 'University',
    applyUrl: 'https://ross.ru.ac.za/'
  },
  {
    name: 'North-West University',
    type: 'University',
    applyUrl: 'https://studies.nwu.ac.za/undergraduate-studies/apply'
  },
  // Top 10 TVET Colleges
  {
    name: 'Tshwane South TVET College',
    type: 'TVET College',
    applyUrl: 'https://www.tsc.edu.za/online-application/'
  },
  {
    name: 'Ekurhuleni East TVET College',
    type: 'TVET College',
    applyUrl: 'https://eec.edu.za/apply-online/'
  },
  {
    name: 'Sedibeng TVET College',
    type: 'TVET College',
    applyUrl: 'https://www.sedcol.co.za/online-applications/'
  },
  {
    name: 'South West Gauteng TVET College',
    type: 'TVET College',
    applyUrl: 'https://www.swgc.co.za/online-applications/'
  },
  {
    name: 'Central Johannesburg TVET College',
    type: 'TVET College',
    applyUrl: 'https://cjc.edu.za/online-application/'
  },
  {
    name: 'Mopani South East TVET College',
    type: 'TVET College',
    applyUrl: 'https://mopanicollege.edu.za/apply/'
  },
  {
    name: 'False Bay TVET College',
    type: 'TVET College',
    applyUrl: 'https://www.falsebaycollege.co.za/apply-now/'
  },
  {
    name: 'Boland TVET College',
    type: 'TVET College',
    applyUrl: 'https://www.bolandcollege.com/online-applications/'
  },
  {
    name: 'Vuselela TVET College',
    type: 'TVET College',
    applyUrl: 'https://www.vuselelacollege.co.za/apply/'
  },
  {
    name: 'Buffalo City TVET College',
    type: 'TVET College',
    applyUrl: 'https://www.bccollege.co.za/online-applications/'
  },
  // All others (universities and TVETs) can be included below for search
  {
    name: 'Durban University of Technology',
    type: 'University of Technology',
    applyUrl: 'https://www.dut.ac.za/apply-to-dut/'
  },
  {
    name: 'Tshwane University of Technology',
    type: 'University of Technology',
    applyUrl: 'https://www.tut.ac.za/study-at-tut/i-want-to-study/application-information'
  },
  // Additional institutions (only appear when searched)
  {
    name: 'Cape Peninsula University of Technology',
    type: 'University of Technology',
    applyUrl: 'https://www.cput.ac.za/study/apply'
  },
  {
    name: 'Vaal University of Technology',
    type: 'University of Technology',
    applyUrl: 'https://www.vut.ac.za/apply-to-vut/'
  },
  {
    name: 'Mangosuthu University of Technology',
    type: 'University of Technology',
    applyUrl: 'https://www.mut.ac.za/apply/'
  },
  {
    name: 'University of Limpopo',
    type: 'University',
    applyUrl: 'https://www.ul.ac.za/index.php?Entity=Apply%20Now'
  },
  {
    name: 'University of Mpumalanga',
    type: 'University',
    applyUrl: 'https://www.ump.ac.za/Study-with-us/Apply-Now'
  },
  {
    name: 'Sol Plaatje University',
    type: 'University',
    applyUrl: 'https://www.spu.ac.za/index.php/how-to-apply/'
  },
  {
    name: 'Walter Sisulu University',
    type: 'University',
    applyUrl: 'https://www.wsu.ac.za/index.php/wsu-online-application/'
  },
  {
    name: 'Sefako Makgatho Health Sciences University',
    type: 'University',
    applyUrl: 'https://www.smu.ac.za/students/apply-to-smu/'
  },
  {
    name: 'University of South Africa (UNISA)',
    type: 'University',
    applyUrl: 'https://www.unisa.ac.za/sites/corporate/default/Apply-for-admission'
  },
  {
    name: 'North-West University',
    type: 'University',
    applyUrl: 'https://studies.nwu.ac.za/undergraduate-studies/apply'
  },
  {
    name: 'Central University of Technology',
    type: 'University of Technology',
    applyUrl: 'https://www.cut.ac.za/application-process/'
  }
];
